
export default {
    IconBtn: {
        icon: true,
        color: 'default',
        variant: 'text',
    },
    VAlert: {
        VBtn: {
            color: undefined,
        },
    },
    VAvatar: {
        // ℹ️ Remove after next release
        variant: 'flat',
    },
    VBadge: {
        // set v-badge default color to primary
        color: 'primary',
    },
    VBtn: {
        // set v-btn default color to primary
        //color: 'primary',
        rounded: 'pill',
        variant: 'tonal',

    },
    VBtnPrimary: {
        // set v-btn default color to primary
        color: 'primary',
        rounded: 'pill',
        variant: 'tonal',

    },
    VBtnSecondary: {
        // set v-btn default color to primary
        color: 'secondary',
        rounded: 'pill',
        variant: 'tonal',

    },
    VCard: {
        rounded: 'lg',
        VBtn: {
            variant: 'tonal',
            rounded: 'pill',
        }
    },
    VCardActions: {
        VBtn: {
            variant: 'tonal',
            rounded: 'pill',
        }
    },
    VChip: {
        elevation: 0,
        rounded: 'pill',
    },
    VContainer: {
        elevation: 0,
    },
    VMenu: {
        offset: '2px',
    },
    VPagination: {
        density: 'comfortable',
        showFirstLastPage: true,
        variant: 'tonal',
        rounded: 'lg',
        class: 'border d-inline-block rounded-lg mx-auto',
        activeColor: 'primary',
    },
    VTabs: {
        // set v-tabs default color to primary
        color: 'primary',
        density: 'comfortable',
        class: 'mt-2 disable-tab-transition'
    },
    VTab: {
        // set v-tabs default color to primary
        variant: 'tonal',
        rounded: 'lg',
        class: 'text-none me-2'
    },
    VTooltip: {
        // set v-tooltip default location to top
        location: 'top',
    },
    VCheckboxBtn: {
        color: 'primary',
    },
    VCheckbox: {
        // set v-checkbox default color to primary
        color: 'primary',
        density: 'comfortable',
        hideDetails: 'auto',
    },
    VRadioGroup: {
        color: 'primary',
        density: 'comfortable',
        hideDetails: 'auto',
    },
    VRadio: {
        density: 'comfortable',
        hideDetails: 'auto',
    },
    VSelect: {
        variant: 'outlined',
        color: 'primary',
        hideDetails: 'auto',
        density: 'comfortable',
    },
    VRangeSlider: {
        // set v-range-slider default color to primary
        color: 'primary',
        thumbLabel: true,
        hideDetails: 'auto',
        trackSize: 6,
        thumbSize: 22,
        elevation: 4,
    },
    VRating: {
        // set v-rating default color to primary
        activeColor: 'warning',
        color: 'disabled',
    },
    VProgressCircular: {
        // set v-progress-circular default color to primary
        color: 'primary',
    },
    VProgressLinear: {
        color: 'primary',
    },
    VSlider: {
        // set v-slider default color to primary
        color: 'primary',
        trackSize: 6,
        hideDetails: 'auto',
        thumbSize: 22,
        elevation: 4,
    },
    VSnackbar: {
        VBtn: {
            size: 'small',
        },
    },
    VTextField: {
        //variant: 'outlined',
        variant: 'solo-filled',
        rounded: 'lg',
        density: 'compact',
        color: 'primary',
        hideDetails: 'auto',
        class: "border rounded-lg",
        flat: true,
    },
    VNumberInput: {
        //variant: 'outlined',
        variant: 'solo-filled',
        rounded: 'lg',
        density: 'compact',
        color: 'primary',
        hideDetails: 'auto',
        class: "border rounded-lg",
        flat: true,
    },
    VAutocomplete: {
        variant: 'outlined',
        color: 'primary',
        density: 'comfortable',
        hideDetails: 'auto',
    },
    VCombobox: {
        variant: 'outlined',
        color: 'primary',
        hideDetails: 'auto',
        density: 'comfortable',
    },
    VFileInput: {
        variant: 'outlined',
        color: 'primary',
        hideDetails: 'auto',
        density: 'comfortable',
    },
    VTextarea: {
        variant: 'outlined',
        color: 'primary',
        hideDetails: 'auto',
        density: 'comfortable',
    },
    VSwitch: {
        // set v-switch default color to primary
        inset: true,
        color: 'primary',
        hideDetails: 'auto',
    },
    VNavigationDrawer: {
        touchless: true,
    },
    VListItem: {
        minHeight: '45px'
    },
    VDataTable: {
        itemsPerPage: 50,
        itemsPerPageOptions: [ 50, 100, 150 ],
        class: 'border rounded-lg hide-mobile-sort datatabels productlist',
        //mobileBreakpoint: 'sm',

    },

}
